export default {
  title: 'Seuraa tilausta',
};
